import { render, staticRenderFns } from "./ReportContainer.vue?vue&type=template&id=2fbd6f7a&"
import script from "./ReportContainer.vue?vue&type=script&lang=js&"
export * from "./ReportContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports